import Grid from '@mui/material/Grid';
import { css, styled } from '@mui/material/styles';

export const StyledContainer = styled(Grid, { shouldForwardProp: prop => prop !== 'applyBackgroundColor' })<{
  applyBackgroundColor?: boolean;
}>`
  ${({ applyBackgroundColor, theme }) =>
    applyBackgroundColor &&
    css`
      background-color: ${theme.palette.background.boxLight};
    `}
`;
